/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Empty Entity Listing Component
  Date: Sept, 2020
**/

import React from 'react';
import {
  Typography,
  Button
} from '@material-ui/core';

const EmptyListingTable = (props) => {
  const {propsHistory, addPermition, addFormLink, textMsg, butnText, standardReportsBtn} = props;

  return (
    <>
      <Typography
        variant="h5"
        style={{
          textAlign: 'center',
          marginTop: '120px',
          fontWeight: '600',
          padding: '10px 0px',
          border: '0px solid #ccc',
          width: '100%',
          ...props.style
        }}
      >
        {textMsg}
        {addPermition && addPermition === true && (
          <Button
            style={{marginLeft: '10px',}}
            variant="contained"
            onClick={() => {props?.handleOnClick ? props?.handleOnClick() : propsHistory.push(`${addFormLink}`)}}
            color="primary"
          >
            {butnText}
          </Button>
        )}
        {standardReportsBtn && standardReportsBtn === true && (
          <Button
            style={{marginLeft: '10px',}}
            variant="contained"
            onClick={() => {propsHistory.push(`/reports/standard`)}}
            color="primary"
          >
            Standard Reports
          </Button>
        )}
      </Typography>
    </>
  );
};

export default EmptyListingTable;
